
const ForwardArrow = (props: React.SVGProps<SVGSVGElement>) => 
    <svg version="1.0" viewBox="0 0 24 24" width={props.width ?? 24} height={props.height ?? 24} >
        <path fill={props.color}
            d="M14 19.0703L21.0703 12L14 4.92969L12.5 6.42969L17.0703 11H3V13H17.0703L12.5 17.5703L14 19.0703Z"
        />
    </svg>;
export default ForwardArrow;